<div class="parent-div">
  <mat-card id="organizations-card">
    <mat-card-header>
      <mat-card-title class="org-header">
        <span>{{ 'dataManagement.manageOrganizations.title.organizationTitle' | transloco }}</span>
        <button mat-raised-button type="button" color="primary" (click)="addOrganization()" class="org-button">
          <mat-icon>add</mat-icon>
          {{ 'dataManagement.manageOrganizations.button.addOrganization' | transloco }}
        </button>

        <button mat-raised-button type="button" color="primary" (click)="bulkUserUpload()" class="org-button">
          <mat-icon>upload</mat-icon>
          {{ 'dataManagement.manageOrganizations.bulkUpload.bulkUserUpload' | transloco }}
        </button>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="scrollable">
      <table mat-table [dataSource]="organizationsDataSource" class="organizations-table" #orgsTableSort="matSort"
        matSort [matSortActive]="sortOrganizationsColumn" matSortDirection="asc">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'dataManagement.manageOrganizations.orgTableColumn.id' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'dataManagement.manageOrganizations.orgTableColumn.name' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="organizationsColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: organizationsColumns;" (click)="onOrganizationClicked(row)"
          [class.selected-row]="clickedOrganizationRow === row"></tr>
      </table>
      <table mat-table *ngIf="deletedOrganizationsDataSource.data.length > 0"
        [dataSource]="deletedOrganizationsDataSource" class="organizations-table deleted-table"
        #delOrgsTableSort="matSort" matSort [matSortActive]="sortOrganizationsColumn" matSortDirection="asc">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'dataManagement.manageOrganizations.orgTableColumn.deletedName' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element" class="deleted-entry"> {{element.name}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="organizationsColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: organizationsColumns;" (click)="onOrganizationClicked(row)"
          [class.selected-row]="clickedOrganizationRow === row"></tr>
      </table>
    </mat-card-content>
  </mat-card>

  <mat-card id="details-card" *ngIf="clickedOrganizationRow; else placeholderCard">
    <mat-card-header>
      <mat-card-title class="org-header">
        <span>{{ clickedOrganizationRow.name }} ({{ 'common.text.id' | transloco }} {{ clickedOrganizationRow.id }})</span>
        <button *ngIf="!clickedOrganizationRow.isDeleted" mat-raised-button type="button" color="warn"
          (click)="deleteOrganization(clickedOrganizationRow)" class="org-button">
          <mat-icon>delete</mat-icon>
          {{ 'dataManagement.manageOrganizations.button.delete' | transloco }}
        </button>
        <button *ngIf="clickedOrganizationRow.isDeleted" mat-raised-button type="button" color="primary"
          (click)="restoreOrganization(clickedOrganizationRow)" class="org-button">
          <mat-icon>delete</mat-icon>
          {{ 'dataManagement.manageOrganizations.button.restore' | transloco }}
        </button>
      </mat-card-title>
    </mat-card-header>
    <mat-tab-group class="mat-elevation-z2" id="tab-group">
      <mat-tab label="{{ 'dataManagement.manageOrganizations.title.generalSettingsTitle' | transloco }}">
        <div>
          <div style="display: flex; align-items: baseline; margin-top: 16px;">
            <mat-checkbox hideIcon color="primary" [formControl]="isContractSignedControl" style="margin: 16px;">{{ 'dataManagement.manageOrganizations.generalSettingsColumn.contractSigned' | transloco }}</mat-checkbox>
            <mat-slide-toggle hideIcon color="primary" [formControl]="isCostCalculationAllowedControl" style="margin: 16px;">{{ 'dataManagement.manageOrganizations.generalSettingsColumn.performCostCalculation' | transloco }}</mat-slide-toggle>
            <mat-slide-toggle hideIcon color="primary" [formControl]="isPPWRAllowedControl" style="margin: 16px;">{{ 'dataManagement.manageOrganizations.generalSettingsColumn.performPPWR' | transloco }}</mat-slide-toggle>
            <mat-slide-toggle hideIcon color="primary" [formControl]="isExcelDownloadAllowedControl" style="margin: 16px;">{{ 'dataManagement.manageOrganizations.generalSettingsColumn.performExcelDownload' | transloco }}</mat-slide-toggle>
            <div style="display: flex; gap: 16px; align-items: baseline; margin: 16px;">
              <mat-slide-toggle hideIcon color="primary" [formControl]="isMaxUserCountActivatedControl">{{ 'dataManagement.manageOrganizations.generalSettingsColumn.maxUserCount' | transloco }}</mat-slide-toggle>
              <mat-form-field>
                <input matInput [formControl]="maxUserCountControl" type="number">
              </mat-form-field>
            </div>
          </div>

          <div style="display: flex; align-items: baseline; margin: 16px; margin-top: 0px">
            <mat-form-field style="width: 40%">
              <mat-label>{{ 'dataManagement.manageOrganizations.generalSettingsColumn.allowedClients' | transloco }}</mat-label>
              <mat-select multiple [formControl]="allowedClientsDropdown" >
                <mat-option *ngFor="let client of allClients" [value]="client.id">
                  {{client.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <button style="margin: 16px;" mat-raised-button color="primary" (click)="updateOrganizationSettings()">{{ 'dataManagement.manageOrganizations.button.saveSettings' | transloco }}</button>
        </div>
      </mat-tab>

      <mat-tab label="{{ 'dataManagement.manageOrganizations.title.creditsTitle' | transloco }}">
        <div class="flex-tab-content">
          <div class="scrollable-subtable">
            <table mat-table [dataSource]="accountsDataSource" id="accounts-table" #accountsTableSort="matSort" matSort>
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'dataManagement.manageOrganizations.accountsTableColumn.id' | transloco }}
                </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'dataManagement.manageOrganizations.accountsTableColumn.name' | transloco }}
                </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>
              <ng-container matColumnDef="recyclabilityCredits">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'dataManagement.manageOrganizations.accountsTableColumn.creditsCountRecyclability' | transloco }}
                </th>
                <td mat-cell *matCellDef="let element"> {{element.recyclabilityCredits}} </td>
              </ng-container>
              <ng-container matColumnDef="lcaCredits">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'dataManagement.manageOrganizations.accountsTableColumn.creditsCountLca' | transloco }}
                </th>
                <td mat-cell *matCellDef="let element"> {{element.lcaCredits}} </td>
              </ng-container>
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'dataManagement.manageOrganizations.accountsTableColumn.edit' | transloco }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <span>
                    <button mat-icon-button color="primary" (click)="editCredits(element)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="primary" (click)="editAuthorizations(element)">
                      <mat-icon>gpp_good</mat-icon>
                    </button>
                  </span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="accountsColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: accountsColumns;"></tr>
            </table>
          </div>
          <div class="button-container">
            <div class="hint margin">
              {{ 'dataManagement.manageOrganizations.messages.accountsCount' | transloco: {count:
              accountsDataSource.data.length} }}
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="{{ 'dataManagement.manageOrganizations.title.userTitle' | transloco }}">
        <div class="flex-tab-content">
          <div class="scrollable-subtable">
            <app-users-table [usersDataSource]="usersDataSource" [deletedUsersDataSource]="deletedUsersDataSource"
              [usersColumns]="usersColumns">
            </app-users-table>

            <button style="margin: 16px;" mat-raised-button color="primary" (click)="updatePremiumUserFlags()">{{ 'dataManagement.manageOrganizations.button.saveSettings' | transloco }}</button>

          </div>
          <div class="button-container">
            <div class="hint margin">
              {{ 'dataManagement.manageOrganizations.messages.usersCount' | transloco: {count:
              usersDataSource.data.length} }}
            </div>
            <div *ngIf="!clickedOrganizationRow.isDeleted">
              <div class="hint margin">
                {{ 'dataManagement.manageOrganizations.messages.addUserHint' | transloco }}
              </div>
              <button mat-raised-button type="button" color="primary" (click)="addUser()">
                <mat-icon>add</mat-icon>
                {{ 'dataManagement.manageOrganizations.button.addUser' | transloco }}
              </button>
            </div>
          </div>
        </div>
      </mat-tab>



      <mat-tab label="{{ 'dataManagement.manageOrganizations.title.visibilityTitle' | transloco }}">
        <div class="flex-tab-content">
          <div class="scrollable-subtable">
            <table mat-table [dataSource]="visibilityDataSource" id="visiblity-table" #visibilityTableSort="matSort"
              matSort matSortDirection="asc" [matSortActive]="sortOrganizationsColumn">
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'dataManagement.manageOrganizations.userTableColumn.id' | transloco }}
                </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'dataManagement.manageOrganizations.userTableColumn.name' | transloco }}
                </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="visibilityColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: visibilityColumns;"></tr>
            </table>
          </div>
          <div class="button-container">
            <div class="hint margin">
              {{ 'dataManagement.manageOrganizations.messages.visibleOrgCount' | transloco: {count:
              visibilityDataSource.data.length} }}
            </div>
            <div *ngIf="!clickedOrganizationRow.isDeleted">
              <div class="hint margin">
                {{ 'dataManagement.manageOrganizations.messages.visibilityHint' | transloco }}
              </div>
              <button mat-raised-button type="button" color="primary" (click)="manageVisibility()">
                <mat-icon>edit</mat-icon>
                {{ 'dataManagement.manageOrganizations.button.manageVisibility' | transloco }}
              </button>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card>

  <ng-template #placeholderCard>
    <mat-card id="placeholder-card">
      <span class="hint margin">Select an organization to see the magic happen</span>
    </mat-card>
  </ng-template>
</div>
